import Footer from "../components/Home/Footer.js";
import Navbar  from "../components/NavBar/NavBar.js";
import Devis from "../components/Partenaires/Devis"
import Whatsapp from "../components/Home/Whatsapp.js";
import Spinner from "../components/Home/Spinner.js";
import { useEffect } from "react";




const Partenaires = () =>{
    useEffect(() => {
  document.title =
    "UNIK SYSTEM | Demande de Devis Personnalisé";

  const meta = document.querySelector("meta[name='description']");
  if (meta) {
    meta.setAttribute(
      "content",
      "Demandez votre devis personnalisé pour plafonds tendus, solutions acoustiques, lumineuses, protection solaire et architecture textile."
    );
  }
}, []);

    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Devis/>
            <Whatsapp/>
            <Footer/>
        </div>    
    )
};

export default Partenaires;